
<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader class="bg-secondary" style="text-align: center"
          >فرم <strong>ثبت نام کاربر</strong>
        </CCardHeader>
        <CCardBody>
          <CForm class="needs-validation" novalidate>
            <h5 class="text-primary mb-3">اطلاعات فردی</h5>
            <hr />

            <CRow>
              <CInput
                class="col-sm-12 col-md-6 col-lg-4"
                label="نام و نام خانوادگی"
                v-model="userInfo.name"
                required
              />
              <CInput class="col-sm-12 col-md-6 col-lg-4" label="نام پدر" />
              <CInput
                class="col-sm-12 col-md-6 col-lg-4"
                label="کدملی"
                required
                v-model="userInfo.codemeli"
              />

              <div role="group" class="col-sm-12 col-md-6 col-lg-4 form-group">
                <label for="uid-vvb5dt2i0jd" class="">تاریخ تولد </label
                ><date-picker
                  class="col-sm-12 col-md-6 col-lg-4 p-0 m-0"
                  v-model="userInfo.birthdayDate"
                >
                  تاریخ تولد</date-picker
                >
              </div>

              <div role="group" class="col-sm-12 col-md-6 col-lg-4 form-group" >
                <label for="uid-vvb5dt2i0jd" class="">جنسیت</label>
                <!-- <Select2
                multiple="multiple"
                  class="m-0 py-1"
                  placeholder="انتخاب..."
                  v-model="userInfo.gender"
                  :options="gender"
                  @change="myChangeEvent($event)"
                  @select="mySelectEvent($event)"
                /> -->
              </div>

              <CInput
                class="col-sm-12 col-md-6 col-lg-4"
                label="ایمیل"
                type="email"
                v-model="userInfo.email"
              />
              <CInput
                class="col-sm-12 col-md-6 col-lg-4"
                label="تلفن همراه"
                required
                v-model="userInfo.mobile"
                maxlength="11"
              />
              <CInput
                class="col-sm-12 col-md-6 col-lg-4"
                label="تلفن ثایت"
                v-model="userInfo.phone"
              />
              <CInput
                class="col-sm-12"
                label="آدرس"
                v-model="userInfo.address"
              />
            </CRow>

            <h5 class="text-primary mb-3 mt-4">اطلاعات حساب کاربری</h5>
            <hr />

            <CRow>
              <CInput
                class="col-sm-12 col-md-6 col-lg-4"
                label="نام کاربری"
                required
                v-model="userInfo.username"
              />
              <CInput
                class="col-sm-12 col-md-6 col-lg-4"
                label="رمزعبور"
                type="password"
                required
                v-model="userInfo.password"
              />

              <CRow
                align-vertical="center"
                class="col-sm-12 col-md-6 col-lg-4 m-0 p-0"
              >
                <CInputCheckbox
                  label="وضعیت فعال بودن"
                  class="mr-3 mb-2"
                  v-model="userInfo.active"
                />
              </CRow>

              <CSelect
                class="col-sm-12 col-md-6 col-lg-4"
                label="نقش"
                :options="options"
                placeholder="انتخاب..."
                required
                v-model="userInfo.role"
              />
            </CRow>

            <h5 class="text-primary mb-3">اطلاعات سازمانی</h5>
            <hr />

            <CRow>
              <CInput
                class="col-sm-12 col-md-6 col-lg-4"
                label="کدپرسنلی"
                v-model="userInfo.codePerseneli"
              />

              <CSelect
                class="col-sm-12 col-md-6 col-lg-4"
                label="اداره"
                :options="options"
                placeholder="انتخاب..."
                v-model="userInfo.office"
              />

              <CSelect
                class="col-sm-12 col-md-6 col-lg-4"
                label="بخش"
                :options="options"
                placeholder="انتخاب..."
                v-model="userInfo.section"
              />
            </CRow>

            <h5 class="text-primary mb-3 mt-4">اطلاعات تکمیلی</h5>
            <hr />

            <CInputFile label="عکس" v-model="userInfo.picture" />
            <CTextarea
              label="توضیحات"
              placeholder="Content..."
              rows="5"
              v-model="userInfo.description"
            />
          </CForm>
        </CCardBody>
        <CCardFooter style="text-align: center">
          <CButton
            type="submit"
            color="primary"
            class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
            v-on:click="submitForm"
            ><CIcon name="cil-check-circle" /> ثبت</CButton
          >
          <CButton
            type="reset"
            color="danger"
            class="col-sm-5 col-md-3 col-lg-2 mx-2 mb-2"
            ><CIcon name="cil-ban" /> پاک کردن</CButton
          >
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>


<script>
import ColorThemeVue from "../theme/ColorTheme.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
// import Select2 from "v-select2-component";

export default {
  name: "Forms",
  data() {
    return {
      userInfo: {
        name: "",
        fatherName: "",
        codemeli: "",
        birthdayDate: "",
        gender: "",
        email: "",
        mobile: "",
        phone: "",
        address: "",
        username: "",
        password: "",
        active: "",
        role: "",
        codePerseneli: "",
        office: "",
        section: "",
        picture: "",
        description: "",
      },
      selected: [], // Must be an array reference!
      show: true,
      horizontal: { label: "col-3", input: "col-9" },
      options: ["Option 1", "Option 2", "Option 3"],
      gender: [
        {
          text: "مرد",
          id: true,
        },
        {
          text: "زن",
          id: false,
        },
      ],
      selectOptions: [
        "Option 1",
        "Option 2",
        "Option 3",
        {
          value: "some value",
          label: "Selected option",
        },
      ],
      selectedOption: "some value",

      formCollapsed: true,
      checkboxNames: [
        "Checkboxes",
        "Inline Checkboxes",
        "Checkboxes - custom",
        "Inline Checkboxes - custom",
      ],
      radioNames: [
        "Radios",
        "Inline Radios",
        "Radios - custom",
        "Inline Radios - custom",
      ],
    };
  },

  components: {
    datePicker: VuePersianDatetimePicker,
    // Select2: Select2,
  },

  methods: {
    submitForm: function () {
      var forms = document.querySelectorAll(".needs-validation");
      console.log(forms);

      for (var i = 0; i < forms[0].length; i++) {
        if (
          forms[0][i].type == "text" &&
          forms[0][i].required &&
          forms[0][i].value.length == 0
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
        } else if (
          forms[0][i].type == "select-one" &&
          forms[0][i].required &&
          forms[0][i].value == ""
        ) {
          document.getElementById(forms[0][i].id).style.borderColor = "red";
        }
      }
    },
  },
};
</script>

<style>
</style>